import React, { useContext, useEffect, useState } from "react";
import {
  Grid2,
  Card,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Menu,
  MenuItem,
  IconButton,
  Tooltip,
  Box,
} from "@mui/material";
import { convertUTCToTimeZone, convertUTCToTimeZoneDateTimeString } from "../Utility/DateTimeUtility";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import dayjs from "dayjs";
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";
import DescriptionIcon from "@mui/icons-material/Description";
import NotesIcon from "@mui/icons-material/Notes";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { DataGrid } from "@mui/x-data-grid";
import { use } from "react";
import { getLinkedServices } from "../API/LinkedServicesApi";
import AuthContext from "../Context/AuthProvider";
import { useSnackbar } from "../Utility/UserMessageContext";
import { MoreHoriz } from "@mui/icons-material";

function PatientVisits({
  currentPatient,
  onViewDocument,
}) {
  const [selectedService, setSelectedService] = useState(null);
  const {showSnackbar} = useSnackbar();
  const [services, setServices] = useState([]);
  const { auth } = useContext(AuthContext);
  const [openServiceDialog, setOpenServiceDialog] = useState(false);
  const [selectedVisit, setSelectedVisit] = useState();
    const [anchorEl, setAnchorEl] = useState(null);
    const [menuDocs, setMenuDocs] = useState([]);

  useEffect(() => {
    if(currentPatient?.visits && currentPatient?.visits.length > 0){
      const sortedVisits = [...currentPatient.visits].sort(
        (a, b) => new Date(b.scheduledStartDateTime) - new Date(a.scheduledStartDateTime)
      );
      currentPatient.visits = sortedVisits;
      setSelectedVisit(sortedVisits[0]);
  }
  }, [currentPatient]);

  useEffect(() => {
    const loadLinkedServices = async () => {
      if (selectedVisit) {
        var result = await getLinkedServices(auth, selectedVisit.id);
        if(result.isSuccess) {
          setServices(result.data);
        }
        else
        {
          showSnackbar("Failed to load linked services", "error");
        }
      }
    };
    loadLinkedServices();
  }, [selectedVisit]);

  // // Handle Service Click
  // const handleServiceClick = (service) => {
  //   setSelectedService(service);
  //   setOpenServiceDialog(true);
  // };

  // // Close Service Dialog
  // const handleCloseServiceDialog = () => {
  //   setOpenServiceDialog(false);
  // };

  // // Handle opening content in a new tab
  // const handleOpenTab = (option, service) => {
  //   if (onViewDocument) {
  //     onViewDocument(option, service); // Pass the option and service to the parent component
  //   }
  // };

  function flattenDocuments(service) {
  // Returns array of {documentType, documentName, documentId, dateUploaded}
  return [
    ...(service?.prescriptionsMetaData || []).map(doc => ({
      documentType: doc?.prescriptionType || "prescription",
      documentName: doc?.prescriptionName || "Prescription",
      documentId: doc?.id, 
      documentDisplayId: doc?.displayId,
    })),
    ...(service?.notesMetaData || []).map(doc => ({
      documentType: "ClinicalNote",
      documentName: doc?.noteName || "Clinical Note",
      documentId: doc?.id, 
      documentDisplayId: doc?.displayId,
    })),
    ...(service?.medicalRecordsMetadata || []).map(doc => ({
      documentId: doc?.id,
      documentType: "MedicalRecord",
      documentName: doc?.recordName || "Medical Record",
      documentDisplayId: doc?.displayId,
    })),
  ];
}

// const handleViewDocument = (doc) => {
//   if(doc.documentType === "prescription") {
//     handleOpenTab(doc.documentId, doc.displayId, doc.documentType); 
//   }
// };

const docTypeIcon = {
  prescription: <DescriptionIcon color="primary" fontSize="small" />,
  clinicalNote: <NotesIcon color="secondary" fontSize="small" />,
  medicalRecord: <MedicalServicesIcon color="success" fontSize="small" />,
};

  const serviceColumns = [
    { field: "serviceCode", headerName: "Service Code", width: 150 },
    { field: "clinicalServiceId", headerName: "Service ID", width: 150 },
    { field: "serviceName", headerName: "Service Name", width: 150 },
    { field: "assignedToUserName", headerName: "Assigned To", width: 150 },
    { 
      field: "scheduledDateTime", 
      headerName: "Date of service", 
      width: 150,   
      valueGetter: (params) =>
        convertUTCToTimeZoneDateTimeString(params?.row?.scheduledStartDateTime, auth?.selectedFacility?.timeZone) 
    },
    {
      field: "actions",
      headerName: "Documents",
      width: 200,
      renderCell: (params) => {
              const docs = flattenDocuments(params.row);
              // Show up to 3 icons, rest in menu
              const iconsToShow = docs.slice(0, 3);
              const extraDocs = docs.slice(3);
      
              return (
                <Box display="flex" alignItems="center">
                  {iconsToShow.map((doc, idx) => (
                    <Tooltip
                      key={doc.documentId}
                      title={doc.documentDisplayId}
                      arrow
                      placement="top"
                    >
                      <IconButton
                        size="small"
                        onClick={() => onViewDocument(doc.documentId, doc.documentDisplayId, doc.documentType)}
                        sx={{ mx: 0.25 }}
                      >
                        {docTypeIcon[doc.documentType] || <DescriptionIcon fontSize="small" />}
                      </IconButton>
                    </Tooltip>
                  ))}
                  {extraDocs.length > 0 && (
                    <>
                      <IconButton
                        size="small"
                        onClick={(e) => {
                          setAnchorEl(e.currentTarget);
                          setMenuDocs(extraDocs);
                        }}
                        sx={{ mx: 0.25 }}
                      >
                        <MoreHoriz />
                      </IconButton>
                      <Menu
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={() => setAnchorEl(null)}
                        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                        transformOrigin={{ vertical: "top", horizontal: "left" }}
                      >
                        {menuDocs.map((doc) => (
                          <MenuItem
                            key={doc.documentId}
                            onClick={() => {
                              onViewDocument(doc.documentId, doc.documentDisplayId, doc.documentType);
                              setAnchorEl(null);
                            }}
                          >
                            {docTypeIcon[doc.documentType] || <DescriptionIcon fontSize="small" />}
                            <Box ml={1}>{doc.documentDisplayId}</Box>
                          </MenuItem>
                        ))}
                      </Menu>
                    </>
                  )}
                </Box>
              );
      },
    },
  ];

  return (
    <Grid2 container size={12}>
      <Accordion defaultExpanded sx={{ width: "100%" }} variant="outlined">
        <AccordionSummary
          sx={{
            minHeight: "40px",
            maxHeight: "40px",
            "&.Mui-expanded": {
              minHeight: "30px",
              maxHeight: "30px",
            },
          }}
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Typography component="span">Visits</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid2 container size={12}>
            {currentPatient?.visits?.length > 0 ? (
              <>
                <Grid2
                  size={12}
                  justifyContent="center"
                  sx={{
                    overflowX: "auto",
                    padding: "16px 0",
                    display: "flex",
                    whiteSpace: "nowrap",
                  }}
                >
                  {currentPatient.visits.map((visit, index) => {
                    return (
                      <Grid2
                        container
                        key={visit.id}
                        sx={{ alignItems: "center", justifyContent: "center", width: "150px" }}
                      >
                        <Grid2 container size={12} sx={{ alignItems: "center", justifyContent: "center" }}>
                          <Grid2 size={2}>
                            <IconButton
                              onClick={() => setSelectedVisit(visit)}
                              sx={{ padding: 0 }}
                            >
                              <Grid2
                                sx={{
                                  width: "16px",
                                  height: "16px",
                                  borderRadius: "100%",
                                  backgroundColor:
                                    selectedVisit?.id === visit.id
                                      ? "#06adaf"
                                      : "#ccc",
                                  border: "2px solid #fff",
                                  boxShadow: "0 0 0 2px #06adaf",
                                }}
                              />
                            </IconButton>
                          </Grid2>
                          <Grid2 size={10}>
                            {index < currentPatient.visits.length - 1 && (
                              <Grid2
                                sx={{
                                  width: "90%",
                                  height: "2px",
                                  backgroundColor: "#ff914d",
                                }}
                              />
                            )}
                          </Grid2>
                        </Grid2>
                        <Grid2 size={12}>
                          <Grid2 size={2} sx={{ justifyItems: "center" }}>
                          <Typography>{dayjs(visit?.scheduledStartDateTime).format("YYYY-MMM-DD")}</Typography>
                            <Typography>{visit.currentVisitType}</Typography>
                          </Grid2>
                          <Grid2 size={10}></Grid2>
                        </Grid2>
                      </Grid2>
                    );
                  })}
                </Grid2>
                {selectedVisit && (
                  <Grid2
                    size={12}
                    sx={{
                      height: 300,
                      width: "100%",
                      marginTop: "16px",
                    }}
                  >
                    <DataGrid
                      density="compact"
                      rows={services}
                      columns={serviceColumns}
                      pageSize={5}
                      rowsPerPageOptions={[5]}
                      disableSelectionOnClick
                      localeText={{
                        noRowsLabel: "No services available for this visit.",
                      }}
                    />
                  </Grid2>
                )}
              </>
            ) : (
              <Grid2
                size={12}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100px",
                }}
              >
                <Typography variant="body1" color="textSecondary">
                  No visits are available.
                </Typography>
              </Grid2>
            )}
          </Grid2>
        </AccordionDetails>
      </Accordion>
    </Grid2>
  );
}

export default PatientVisits;